/* ANATOMY Science Library — instant topic filter + search.
   No dependencies. Filters .lib-card wrappers by data-topics / data-title.
   The featured flagship hides whenever a topic filter or search is active. */
(function () {
  'use strict';

  function init() {
    var chips = Array.prototype.slice.call(document.querySelectorAll('.lib-chip'));
    var cards = Array.prototype.slice.call(document.querySelectorAll('.lib-card'));
    if (!chips.length || !cards.length) return;

    var search = document.getElementById('LibrarySearch');
    var featured = document.querySelector('[data-library-featured]');
    var countEl = document.querySelector('[data-library-count]');
    var noResults = document.querySelector('[data-library-noresults]');
    var total = cards.length;
    var defaultLabel = countEl ? countEl.textContent : '';

    var activeTopic = 'all';
    var query = '';

    function apply() {
      var q = query.trim().toLowerCase();
      var visible = 0;
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var topics = ' ' + (card.getAttribute('data-topics') || '') + ' ';
        var title = card.getAttribute('data-title') || '';
        var okTopic = activeTopic === 'all' || topics.indexOf(' ' + activeTopic + ' ') > -1;
        var okSearch = !q || title.indexOf(q) > -1;
        var show = okTopic && okSearch;
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      }

      var pristine = activeTopic === 'all' && !q;
      if (featured) featured.classList.toggle('is-hidden', !pristine);
      if (countEl) countEl.textContent = pristine ? defaultLabel : (visible + (visible === 1 ? ' result' : ' results'));
      if (noResults) noResults.hidden = visible > 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeTopic = chip.getAttribute('data-topic') || 'all';
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    if (search) {
      var t;
      search.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          query = search.value;
          apply();
        }, 120);
      });
      // Enter should not submit / reload
      search.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') e.preventDefault();
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
